import { Headset } from "lucide-react";

// App brand icon — headset (kept as `DroneIcon` so all existing usages/colours work).
export const DroneIcon = ({ className = "", strokeWidth = 2, ...props }) => (
  <Headset className={className} strokeWidth={strokeWidth} {...props} />
);

export default DroneIcon;
